// Stable browser entry — Blocks may overwrite aws-blocks/client.js on server start.
import { ApiNamespaceClient } from '@aws-blocks/blocks/client';

const url = import.meta.env.VITE_BLOCKS_API_URL || '/aws-blocks/api';

export const api = ApiNamespaceClient('api', { url });
export const authApi = ApiNamespaceClient('authApi', { url });

export const generateClient = (config) => ({
  api: ApiNamespaceClient('api', config),
  authApi: ApiNamespaceClient('authApi', config),
});
